import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { ProjectService } from '../../../api/services/project.services';
import { ProjectHealth } from '../../../api/models/project-health';
import { TasksService } from '../../../api/services/tasks.service';
import { TaskCount } from '../../../api/models/task';

@Component({
  selector: 'app-project-health',
  templateUrl: './project-health.component.html',
  styleUrls: ['./project-health.component.scss']
})
export class ProjectHealthComponent implements OnInit, OnChanges {

  @Input() projectId: string;
  @Input() projectName: string;
  @Input() accountNumber: string;
  @Input() showDetails = false;
  @Output() appliedFilter = new EventEmitter<any>();

  @Input() canViewAvailability = false;
  @Input() projectListFlag = false;
  @Input() projectHealth: ProjectHealth;
  openTasks: TaskCount[] = [];
  totalTaskCount = 0;
  healthOnTarget = 0;
  healthOffTarget = 0;
  countOfShippedSkus = 0;
  countOfDeliveredSkus = 0;

  constructor(
    private projectService: ProjectService,
    private tasksService: TasksService
    ) { }

  getRoundNumber(number: number) {
    return Math.round(number);
  }

  onAppliedFilter(filter: any) {
    this.appliedFilter.emit(filter);
  }

  ngOnInit() {
    this.setOpenTasks();
    
    this.setHealth(this.canViewAvailability, this.projectHealth);
  }

  setHealth(canViewAvailability: boolean, projectHealth: ProjectHealth) {
    if (canViewAvailability) {
      if (projectHealth) {
        this.setProjectHealthData(projectHealth);
      } else {
        this.projectService.getProjectHealth(this.projectId, this.projectListFlag).subscribe(health => {
          this.projectHealth = health;
          this.setProjectHealthData(this.projectHealth);
        });
      }
    }
  }

  setProjectHealthData(projectHealth: ProjectHealth) {
    this.healthOffTarget = projectHealth.availabilityItemsOffTarget;
    this.healthOnTarget = projectHealth.availabilityItemsOnTarget;
    this.countOfShippedSkus = projectHealth.countOfShippedItems;
    this.countOfDeliveredSkus = projectHealth.countOfDeliveredItems;
  }

  setOpenTasks() {
    this.tasksService.getTasksCountByProject(this.projectId ,this.projectName, this.accountNumber).subscribe(tasksCount => {
      this.openTasks = tasksCount;
      if(this.openTasks && this.openTasks.length){
        this.openTasks.forEach(task => {
          this.totalTaskCount = this.totalTaskCount + task.count;
        });
      } else {
        this.totalTaskCount = 0;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    let canViewAvailability: SimpleChange = changes.canViewAvailability;
    if (canViewAvailability !== undefined && canViewAvailability !== null) {
      this.canViewAvailability = canViewAvailability.currentValue;
    }
    let projectHealth: SimpleChange = changes.projectHealth;
    if (projectHealth !== undefined && projectHealth !== null) {
      this.projectHealth = projectHealth.currentValue;
    }
    this.setHealth(this.canViewAvailability, this.projectHealth);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-my-oasis/project-health/project-health.component.ts